<template>
	<div :style="'overflow-x: hidden;background:' + bgColor">
		<div>
			<div class="banner-c"><img :src="imageConfig.imageList && imageConfig.imageList[0].url"></div>
		</div>
		<div class="crumbs-all">
			<div class="crumbs-c" v-if="lang === 'zh'">
				<div @click="$router.push('/' + lang)" style="cursor: pointer;">首页 </div>> 联系我们
			</div>
			<div class="crumbs-c" v-if="lang === 'en'">
				<div @click="$router.push('/' + lang)" style="cursor: pointer;">Home </div> > Contact
			</div>
			<div class="crumbs-c" v-if="lang === 'ko'">
				<div @click="$router.push('/' + lang)" style="cursor: pointer;">첫 페이지 </div> > 연락처
			</div>
			<div class="crumbs-c" v-if="lang === 'ja'">
				<div @click="$router.push('/' + lang)" style="cursor: pointer;">最初のページ </div>> 連絡先
			</div>
		</div>
		<div class="contact-c content-bd" :style="'background:' + imageConfig.contentColor">
			<!-- <div class="html-c">
				<div v-html="imageConfig.content" style="width: 100%;"></div>
				
			</div> -->
			<div class="phone-c">
				<div class="line-c">
					<div class="ico"></div>
					<div class="value" v-if="lang==='zh'">{{ imageConfig.address_zh }}</div>
					<div class="value" v-if="lang==='en'">{{ imageConfig.address_en }}</div>
					<div class="value" v-if="lang==='ja'">{{ imageConfig.address_ja }}</div>
				</div>
				<div class="line-c">
					<div class="ico1"></div>
					<div class="value" v-if="lang==='zh'">{{ imageConfig.phone_zh }}</div>
					<div class="value" v-if="lang==='en'">{{ imageConfig.phone_en }}</div>
					<div class="value" v-if="lang==='ja'">{{ imageConfig.phone_ja }}</div>
				</div>
				<div class="line-c">
					<div class="ico2"></div>
					<div class="value" v-if="lang==='zh'">{{ imageConfig.fax_zh }}</div>
					<div class="value" v-if="lang==='en'">{{ imageConfig.fax_en }}</div>
					<div class="value" v-if="lang==='ja'">{{ imageConfig.fax_ja }}</div>
				</div>
				<div class="line-c">
					<div class="ico3"></div>
					<div class="value" v-if="lang==='zh'">{{ imageConfig.email_zh }}</div>
					<div class="value" v-if="lang==='en'">{{ imageConfig.email_en }}</div>
					<div class="value" v-if="lang==='ja'">{{ imageConfig.email_ja }}</div>
				</div>
			</div>
			<div style="width:635px;height:190px">
				<el-amap vid="amap" :plugin="plugin" class="amap-demo" :zoom="zoom" :center="center">
					<el-amap-marker :position="[120.909, 30.015771]" label="公司地址">

					</el-amap-marker>
				</el-amap>
				<!-- <el-amap vid="amapDemo" :zoom="zoom" :center="center">
				<el-amap-marker :position="[112,33]" label="公司地址">

				</el-amap-marker>
			</el-amap> -->
			</div>

		</div>
		<!-- <div @click="test" style="margin-left:200px">打开地图</div> -->

		<p-bottom :lang="lang"></p-bottom>
	</div>
</template>

<script>
import Vue from 'vue'
import VueAMap from 'vue-amap'
VueAMap.initAMapApiLoader({
	key: '863a6c740792539da67b981ad179e802',
	// 插件集合 （插件按需引入）
	plugin: ['AMap.Geolocation'],
	v: '1.4.4'
})
Vue.use(VueAMap)
const jsonp = require('jsonp')
export default {
	name: 'Main',
	props: {
		lang: {}
	},
	data() {
		return {
			businessUnit: [],
			departmentList: [{ zh: "销售", en: "Sale", ko: "판매", ja: "販売する", value: 0 }, { zh: "采购", en: "Purchasing", ko: "구매", ja: "買い付ける", value: 1 }, { zh: "人力资源", en: "HR", ko: "인적 자원", ja: "人的資源", value: 2 }],
			selectedBusiness: '',
			selectedDepartment: '',
			companyName: '',
			position: '',
			personalName: '',
			contact: '',
			content: '',
			imageConfig: { indexSecond: '' },
			bgColor: '#fff',
			currentMail: '',
			center: [120.909, 30.015771],
			zoom: 17, // 初始化地图显示层级
			lng: 0,
			lat: 0,
			loaded: false,
			plugin: [{
				enableHighAccuracy: true,//是否使用高精度定位，默认:true
				timeout: 100,          //超过10秒后停止定位，默认：无穷大
				maximumAge: 0,           //定位结果缓存0毫秒，默认：0
				convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
				showButton: true,        //显示定位按钮，默认：true
				buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
				showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
				showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
				panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
				zoomToAccuracy: true,//定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
				extensions: 'all',
				pName: 'Geolocation',
				events: {
					init(o) {
						// o 是高德地图定位插件实例
						o.getCurrentPosition((status, result) => {
							console.log(result)
							if (result && result.position) {
								self.lng = result.position.lng;
								self.lat = result.position.lat;
								self.center = [self.lng, self.lat];
								self.loaded = true;
								self.$nextTick();
							}
						});
					}
				}
			}]
		}
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		"$route": "getImage"
	},
	created() {
		console.log(this.lang)
		this.getImage()
		//   this.getCompanyList()
	},
	methods: {
		async getCompanyList() {
			const res = await this.$http.post('companyList')
			this.businessUnit = res.data || {}
		},
		getBussinessName(business) {
			if (this.lang == "zh") {
				return business.zh
			} else if (this.lang == "en") {
				return business.en
			}
			else if (this.lang == "ko") {
				return business.ko
			}
			else if (this.lang == "ja") {
				return business.ja
			}
		},
		test() {
			// $.ajax({
			//         type: 'GET',
			//         url: 'http://api.map.baidu.com/marker?location=40.047669,116.313082&title=我的位置&content=百度奎科大厦&output=html&src=webapp.baidu.openAPIdemo',
			//         dataType: 'jsonp',
			//         jsonpCallback: 'callback'
			//     });
			// jsonp('http://api.map.baidu.com/marker?location=40.047669,116.313082&title=我的位置&content=百度奎科大厦&output=html&src=webapp.baidu.openAPIdemo',null,(err,data)=>{

			// })
			// this.$http.get('http://api.map.baidu.com/marker?location=40.047669,116.313082&title=我的位置&content=百度奎科大厦&output=html&src=webapp.baidu.openAPIdemo')
			window.location.href = "http://api.map.baidu.com/marker?location=40.047669,116.313082&title=百度奎科大厦&content=百度奎科大厦&output=html&src=webapp.baidu.openAPIdemo"
		},
		selectCompany(data) {
			console.log(data)
			// mailbox
		},
		fitMail(data) {

			if (this.selectedDepartment.value === 0) {
				this.currentMail = this.selectedBusiness.sellerMailbox
			} else if (this.selectedDepartment.value === 1) {
				this.currentMail = this.selectedBusiness.purchaseMailbox
			} else if (this.selectedDepartment.value === 2) {
				this.currentMail = this.selectedBusiness.peopleMailbox
			}
			console.log(this.currentMail)
		},
		getPHContent(type) {
			if (this.lang == "zh") {
				if (type === 1) {
					return '请输入公司'
				} else if (type === 2) {
					return '请输入联系方式'
				} else if (type === 3) {
					return '请输入姓名'
				} else {
					return '请输入职位'
				}
			} else if (this.lang == "en") {
				if (type === 1) {
					return 'Please enter company'
				} else if (type === 2) {
					return 'Please enter contact information'
				} else if (type === 3) {
					return 'Please enter your name'
				} else {
					return 'Please enter position'
				}
			}
			else if (this.lang == "ko") {
				if (type === 1) {
					return '회사를 입력하십시오'
				} else if (type === 2) {
					return '연락처를 입력해주세요'
				} else if (type === 3) {
					return '이름을 입력하십시오'
				} else {
					return '직위를 입력하십시오'
				}
			}
			else if (this.lang == "ja") {
				if (type === 1) {
					return '会社を入力してください'
				} else if (type === 2) {
					return '連絡先を入力してください'
				} else if (type === 3) {
					return '名前を入力してください'
				} else {
					return '職位を入力してください'
				}
			}
		},
		async getImage() {
			const res = await this.$http.post('contactConfig', { la: 'zh' }) //this.lang

			this.imageConfig = res.data[0] || {}
			if (!this.imageConfig) {
				this.imageConfig = {}
			}
			this.bgColor = this.imageConfig.bgColor
			// this.getPHContent()
		},
		async submit() {
			if (!this.selectedBusiness) {
				alert("请选择事业部 ");
				return
			}
			if (!this.selectedDepartment) {
				alert("请选择事 部门");
				return
			}
			if (!this.companyName) {
				alert("请填写公司名称");
				return
			}
			if (!this.position) {
				alert("请填写职位");
				return
			}
			if (!this.personalName) {
				alert("请填写姓名");
				return
			}
			if (!this.contact) {
				alert("请填写联系方式");
				return
			}
			if (!this.content) {
				alert("请填写要反馈的内容");
				return
			}
			var data = {
				language: this.lang,
				belong: this.selectedBusiness._id,
				mailbox: this.currentMail,
				companyName: this.selectedBusiness.companyName,
				department: this.getBussinessName(this.selectedDepartment),
				company: this.companyName,
				position: this.position,
				name: this.personalName,
				telphone: this.contact,
				content: this.content,
			};
			console.log(data);
			const res = await this.$http.post('createContact', data);
			if (res.status == 200) {
				alert("您好(success)，您的反馈我们已经收到，感谢您，我们会及时处理")
				this.selectedBusiness = '';
				this.selectedDepartment = "";
				this.companyName = "";
				this.position = "";
				this.personalName = "";
				this.contact = "";
				this.content = "";
			}
		}
	},
	//   watch: {
	//   			// 如果路由有变化，会再次执行该方法
	//   			"$route": "fetch"
	//   }


}
</script>
<style lang="scss" scopd> 
.contact-c {
 	background: #fafafa;
 	padding: 28px 0px 18px 0;
 	display: flex;
 	flex-direction: row;
	align-items: center;
 }

 .contact-c .html-c {
 	width: 460px;
 	margin-left: 100px;
 }
 .phone-c{
	margin: 10px 130px 10px 200px;
 }
 .line-c {
    display: flex;
    flex-direction: row;
    font-size: 14px;
    margin-bottom: 12px;
    .name{
   

    }
		.value{
			max-width: 200px;
		}
    .ico {
      width: 30px;
      height: 30px;
      background: url(../assets/images/contact_ico.png) -0px 0px no-repeat;
      background-size: 100%;
    }

    .ico1 {
      width: 30px;
      height: 30px;
      background: url(../assets/images/contact_ico.png) -0px -49px no-repeat;
      background-size: 100%;
    }

    .ico2 {
      width: 30px;
      height: 30px;
      background: url(../assets/images/contact_ico.png) -0px -84px no-repeat;
      background-size: 100%;
    }

    .ico3 {
      width: 30px;
      height: 30px;
      background: url(../assets/images/contact_ico.png) -0px -115px no-repeat;
      background-size: 100%;
    }
  }
 .contact-c .html-c img {
 	width: 100%;
 }
 .contact-c .html-c .line-c{
	display: flex;
	flex-direction: row;
 }
 .map-container {
 	border: 1px solid #000000;
 	height: 620px;
 	width: 100%;
 }

 .banner-c {
 	position: relative;
 	width: 100%;
 	height: 460px;
 	overflow: hidden;
 }

 .banner-c img {
 	position: absolute;
 	left: 0;
 	width: 1920px;
 	margin: 0 calc(50% - 960px);
 }

 .contact-c .input-c {
 	margin-top: 16px;
 	display: flex;
 	flex-direction: row;
 	align-items: center;
 }

 .contact-c .input-c .title {
 	font-size: 18px;
 	color: #666;
 	margin-right: 12px;
 	min-width: 190px;
 	font-weight: 600;
 }

 .contact-c .input-c input {
 	width: 442px;
 	border: 1px solid#e6e6e6;
 	height: 49px;
 	padding: 0 6px;
 }

 .contact-c .input-c textarea {
 	width: 450px;
 	border: 1px solid#e6e6e6;
 	height: 117px;
 }

 .contact-c .submit-bt {
 	width: 174px;
 	height: 56px;
 	text-align: center;
 	font-size: 22px;
 	line-height: 56px;
 	color: #fff;
 }

 .right-c .select-c {
 	padding: 11px 46px 46px 46px;
 	margin-bottom: 39px;
 }

 .right-c .select-c .title {
 	font-size: 18px;
 	color: #666;
 	margin-bottom: 14px;
 	;
 	font-weight: 600;
 }

 .right-c .select-c select {
 	width: 277px;
 	height: 42px;
 	background: #fff;
 	line-height: 42px;
 	color: #989898;
 	font-size: 16px;
 	padding: 4px;
 }

 .contact-c .submit-bt {
 	width: 174px;
 	height: 58px;
 	background: #478ee1;
 	color: #fff;
 	text-align: center;
 	margin-top: 50px;
 	cursor: pointer;
 }</style>